import apiClient from "../../../network/apiClient";

export const addFoodItemAPI = body => apiClient.post("/foodItem/create", body)
export const fetchFoodItemsAPI = () => apiClient.get("/foodItem/getAll", { handle404Silently: true })
export const deleteFoodItemByIdAPI = ( id ) => apiClient.delete(`/foodItem/delete/${id}`)
export const updateFoodItemAPI = (body) => apiClient.put("/foodItem/update", body)